import request from '@/utils/request'

export function getGroupInfo() {
  return request({
    url: '/Overview/get',
    method: 'post'
  })
}

export function getGroupProducts() {
  return request({
    url: '/Product/get',
    method: 'post'
  })
}